export const environment = {
  production: true,
  baseURL: "https://wts.rightfullabs.com/apis/",
};
